import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import './CrystalBalance.css';

export const CrystalBalance: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useUser();

  const balance = (user as any)?.balance || user?.game_stats?.total_points || 0;

  const handleClick = () => {
    navigate('/balance');
  };

  return (
    <div className="crystal-balance" onClick={handleClick}>
      <span className="crystal-balance-amount">{balance}</span>
      <span className="crystal-balance-icon">🌻</span>
    </div>
  );
};

